/**
 * Debug utility for platform authentication
 * Use this to verify JWT tokens are being properly stored and sent
 */

import { getCurrentOrgSlug, getTenantScopedStorageKey } from './tenant';

export const debugPlatformAuth = () => {
  console.group('🔍 Platform Auth Debug');
  
  const orgSlug = getCurrentOrgSlug();
  const userKey = getTenantScopedStorageKey('user', orgSlug);
  const roleKey = getTenantScopedStorageKey('role', orgSlug);
  const selectionKey = getTenantScopedStorageKey('userSelection', orgSlug);
  const organizationKey = getTenantScopedStorageKey('organization', orgSlug);
  const expectedRoleKey = getTenantScopedStorageKey('expectedUserRole', orgSlug);
  
  const tenantUser = localStorage.getItem(userKey);
  const tenantRole = localStorage.getItem(roleKey);
  const tenantSelection = localStorage.getItem(selectionKey);
  const tenantOrg = localStorage.getItem(organizationKey);
  const tenantExpected = localStorage.getItem(expectedRoleKey);
  
  console.log('📦 tenant-scoped storage:');
  console.log('  - org slug:', orgSlug);
  console.log('  - user:', tenantUser ? JSON.parse(tenantUser) : 'NOT FOUND');
  console.log('  - role:', tenantRole || 'NOT FOUND');
  console.log('  - selection:', tenantSelection || 'NOT FOUND');
  console.log('  - organization:', tenantOrg ? JSON.parse(tenantOrg) : 'NOT FOUND');
  console.log('  - expected role:', tenantExpected || 'NOT FOUND');
  
  // Check cookies
  const cookies = document.cookie.split(';').reduce((acc, cookie) => {
    const [key, value] = cookie.trim().split('=');
    acc[key] = value;
    return acc;
  }, {});
  
  console.log('🍪 Cookies:');
  console.log('  - Session cookies (HttpOnly) present:', Object.keys(cookies).length > 0 ? 'POSSIBLE' : 'NONE VISIBLE');
  
  // Check tokenManager
  import('../services/auth/tokenManager').then(({ default: tokenManager }) => {
    const userData = tokenManager.getUserData();
    
    console.log('🔑 TokenManager:');
    console.log('  - getUserData():', userData);
    console.log('  - isAuthenticated():', tokenManager.isAuthenticated());
  });
  
  console.log('🔧 To test organization creation:');
  console.log('1. Clear all storage: localStorage.clear(); document.cookie.split(";").forEach(c => document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"));');
  console.log('2. Login via platform magic link');
  console.log('3. Run debugPlatformAuth() again to verify token is stored');
  console.log('4. Try creating an organization');
  console.log('5. Check Network tab for Authorization header');
  
  console.groupEnd();
};

// Auto-expose to window for easy console access
if (typeof window !== 'undefined') {
  window.debugPlatformAuth = debugPlatformAuth;
}
